import React from 'react';
import { useNavigate } from 'react-router-dom';

const Goal4 = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/#sdg-goals');
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <button
        onClick={handleGoBack}
        className="mb-6 flex items-center text-gray-600 hover:text-gray-900 transition-colors duration-200"
      >
        <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
        Go Back
      </button>
      <h2 className="text-3xl font-bold mb-4">SDG 4 Quality education</h2>
      <p className="text-lg mb-4">
        Ensure inclusive and quality education for all and promote lifelong learning.
      </p>
      <a
        href="https://sdg-tracker.org/quality-education"
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-600 hover:underline mb-6 inline-block"
      >
        https://sdg-tracker.org/quality-education
      </a>

      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">No.</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Targets</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Target Details</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">4.1</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Free primary and secondary education</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2030, ensure that all girls and boys complete free, equitable and quality primary and secondary education leading to relevant and effective learning outcomes.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">4.2</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Equal access to quality pre-primary education</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2030, ensure that all girls and boys have access to quality early childhood development, care and pre-primary education so that they are ready for primary education.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">4.3</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Equal access to affordable technical, vocational and higher education</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2030, ensure equal access for all women and men to affordable and quality technical, vocational and tertiary education, including university.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">4.4</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Increase the number of people with relevant skills for financial success</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2030, substantially increase the number of youth and adults who have relevant skills, including technical and vocational skills, for employment, decent jobs and entrepreneurship.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">4.5</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Eliminate all discrimination in education</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2030, eliminate gender disparities in education and ensure equal access to all levels of education and vocational training for the vulnerable, including persons with disabilities, indigenous peoples and children in vulnerable situations.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">4.6</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Universal literacy and numeracy</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2030, ensure that all youth and a substantial proportion of adults, both men and women, achieve literacy and numeracy.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">4.7</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Education for sustainable development and global citizenship</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2030, ensure that all learners acquire the knowledge and skills needed to promote sustainable development, including, among others, through education for sustainable development and sustainable lifestyles, human rights, gender equality, promotion of a culture of peace and non-violence, global citizenship and appreciation of cultural diversity and of culture’s contribution to sustainable development.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">4.A</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Build and upgrade inclusive and safe schools</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                Build and upgrade education facilities that are child, disability and gender sensitive and provide safe, non-violent, inclusive and effective learning environments for all.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">4.B</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Expand higher education scholarships for developing countries</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2020, substantially expand globally the number of scholarships available to developing countries, in particular least developed countries, small island developing States and African countries, for enrolment in higher education, including vocational training and information and communications technology, technical, engineering and scientific programmes, in developed countries and other developing countries.
              </td>
            </tr>
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">4.C</td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">Increase the supply of qualified teachers in developing countries</td>
              <td className="px-6 py-4 text-sm text-gray-900">
                By 2030, substantially increase the supply of qualified teachers, including through international cooperation for teacher training in developing countries, especially least developed countries and small island developing States.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Goal4;
